// (function validateBackendURL() {
//   const baseURL = process.env.REACT_APP_BACKEND_URL;

//   console.log("🔍 BACKEND URL (ENV):", baseURL);

//   // Validate presence
//   if (!baseURL) {
//     document.body.innerHTML = `
//       <div style="padding:40px;font-size:20px;color:red;">
//         🚨 ERROR: REACT_APP_BACKEND_URL is missing.<br>
//         Please set it to:<br><b>https://estatecoin.in</b>
//       </div>`;
//     throw new Error("Missing REACT_APP_BACKEND_URL");
//   }

//   // Test final URL
//   const testURL = `${baseURL}/api/auth/me`;
//   console.log("🔍 FULL TEST URL:", testURL);

//   // HARD PROTECTION: block app from loading if the URL is incorrect
//   if (testURL.includes("/api/api")) {
//     console.error("🚨 INVALID BACKEND URL: Detected '/api/api'. App blocked.");
//     document.body.innerHTML = `
//       <div style="padding:40px;font-size:20px;color:red;">
//         🚨 CRITICAL ERROR:<br>
//         Backend URL is INVALID.<br><br>
//         Detected <b>/api/api</b> in API requests.<br><br>
//         FIX IMMEDIATELY:<br>
//         Set <b>REACT_APP_BACKEND_URL=https://estatecoin.in</b>
//       </div>`;
//     throw new Error("Invalid backend URL - app blocked for safety.");
//   }

//   console.log("✅ Backend URL validated:", testURL);
// })();

import axios from "axios";
axios.defaults.withCredentials = true;

// Polyfill for crypto.randomUUID (Safari / older browsers)
if (!crypto.randomUUID) {
  crypto.randomUUID = () =>
    ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
    );
}

import React from "react";
import ReactDOM from "react-dom/client";
import ReactPixel from "react-facebook-pixel";
import "./index.css";
import App from "./App.js";
import { AuthProvider } from "./contexts/AuthContext";
import { SocketProvider } from "./contexts/SocketContext";
import { SystemStatusProvider } from "./contexts/SystemStatusContext";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

const pixelId = "1028156442696723";
if (pixelId && pixelId !== "YOUR_PIXEL_ID") {
  ReactPixel.init(pixelId);
  ReactPixel.pageView();
}

// Unregister service worker to avoid stale cache (was serving old index.html / wrong JS)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => registration.unregister());
    });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
    <BrowserRouter>
      <AuthProvider>
        <SystemStatusProvider>
          <SocketProvider>
            <App />
          </SocketProvider>
        </SystemStatusProvider>
      </AuthProvider>
    </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
);
